import React from 'react';
import DsLabel from '../label';
import DsBtn from '../btn/index';

const getIconClass = (variant) => {
  switch (variant) {
    case 'check':
      return 'text-status-green';
    case 'primary':
    case 'tick':
    case 'contact':
      return 'text-primary';
    case 'teal':
      return 'text-teal-400';
    default:
      return '';
  }
};
const List = ({
  className,
  items,
  variant,
  iconDefault,
  children,
  selectedItem,
  onChange,
  textKey,
}) => {
  if (!items) {
    return null;
  }
  const getTitle = (item) => item[textKey] || item.title;

  const getIsActive = (activeItem, currentId) => {
    if (!activeItem) {
      return false;
    }
    const title = getTitle(activeItem);
    return title === currentId;
  };

  const onClickAction = (ev, item) => {
    ev.preventDefault();
    return (onChange ? onChange(item) : null);
  };
  return (
    <ul className={`relative ${className || ''}`}>
      {items.map((item, index) => {
        const {
          subtitle, id, href,
        } = item;
        const title = getTitle(item, textKey);
        if (!title) {
          return null;
        }
        const keyId = id || `${title}_${index}`;
        const isActive = getIsActive(selectedItem, id || title);
        const iconAfter = isActive && (variant === 'tick' ? 'check-tick' : null);
        const isDot = variant === 'dot';
        const isCheck = variant === 'check' ? 'check' : null;
        const icon = isCheck || item.icon || iconDefault;
        return (
          <li key={keyId} className={'flex flex-wrap flex-center'}>
            <DsBtn
              icon={icon}
              iconAfter={iconAfter}
              variant={variant || ''}
              onClick={(ev) => onClickAction(ev, item)}
              className={`py-1  flex-grow-default ${isActive ? 'text-primary' : ''}`}
              iconClassName={getIconClass(variant)}
              href={href}
            >
              {isDot && <div className={`radio-dot ${isActive ? 'active' : ''} mr-2`} />}
              {title}
            </DsBtn>

            {subtitle && (
              <DsLabel className="opacity-75 text-sm whitespace-nowrap">
                {subtitle}
              </DsLabel>
            )}
          </li>
        );
      })}
      {children}
    </ul>
  );
};

export default List;
